import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import { useAuth0 } from '@auth0/auth0-react';
import ListaArticoliAreaTradFromPS from './pezziDB/ListaArticoliAreaTradFromPS';
import SubHeaderTrad from '../../navigadbsections/navigaDBsubMenu/SubHeaderTrad';


function DBperAreaTraduzioniFromPS({ product, setProductFunction, utente, charCount, setCharCount, setTradPermessa, tradPermessa }) {


  const { user, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [listaArticoli, setlistaArticoli] = useState([]);
  const [filterText, setFilterText] = useState('');
  const filteredItemsNome = listaArticoli.filter(
      item => item.brand && item.brand.toLowerCase().includes(filterText.toLowerCase()),
    );
  /* const [anteprimaProdotto, setAnteprimaProdotto] = useState("no data"); */

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    fetch(apiUrl + "/prodotti/get/getProductsFromQuery93_tradFR/", { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => setlistaArticoli(data))
  }, [token]);


  useEffect(() => {
    const getUserMetadata = async () => {

      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();


  }, [getAccessTokenSilently, user?.sub]);

  const aggiorna = function () {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    fetch(apiUrl + "/prodotti/get/getProductsFromQuery93_tradFR/", { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => setlistaArticoli(data))
  }

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
        setFilterText(value);
    } catch (err) {
        console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
        throw err;
    }
}

  return (
    <div class="center">
      <div className='subHeader'>
        <SubHeaderTrad
          titolo="QUERY: Traduzioni in FR mancanti su PS"
          charCount={charCount}
          setCharCount={setCharCount}
          setTradPermessa={setTradPermessa}
          funzAggiorna={aggiorna}
        />

      </div>
      <div className='gruppoInputRicercaOrizzontale'>
                <label className='mr1 b nonSelezionabile' for="filterText">BRAND</label>
                <input
                    value={filterText}
                    name="filterText"
                    onChange={handleChange}
                    id="filterText"
                    className="input-reset inputOrizzontale"
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div> 
      <div class="cf contentSubSubHeader flex">
      
        <div class="fl-ns w-100 pr1 pl1 sfondoBiancoTema">
          
          <ListaArticoliAreaTradFromPS
            setProductFunction={setProductFunction}
            listaArticoli={filterText.length>1 ? filteredItemsNome : listaArticoli}
            utente={utente}
            /* setAnteprimaProdotto={setAnteprimaProdotto} */
            tradPermessa={tradPermessa}
          />
        </div>
        {/* <div className='w-100 w-30-ns sfondoBiancoTema'>
                    {anteprimaProdotto !== "no data" && <SchedaProdotto className="" prodotto={anteprimaProdotto} lang="it" html={false} />}
                </div> */}
      </div>
    </div>

  )
}


export default DBperAreaTraduzioniFromPS;
